export default __webpack_public_path__ + "static/media/573.0589ef34.png";